// Embed helper: detect video type and produce embed URL
export function parseVideoUrl(url) {
  if (!url) return { type: "unknown", embedUrl: null, thumbnail: null, providerLabel: "" };
  const u = url.trim();

  // YouTube
  const ytShort = u.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/);
  const ytLong = u.match(/youtube\.com\/(?:watch\?v=|shorts\/|embed\/)([A-Za-z0-9_-]{6,})/);
  const ytId = ytShort?.[1] || ytLong?.[1];
  if (ytId) {
    return {
      type: "youtube",
      embedUrl: `https://www.youtube.com/embed/${ytId}?rel=0&modestbranding=1`,
      thumbnail: `https://i.ytimg.com/vi/${ytId}/hqdefault.jpg`,
      providerLabel: "YouTube",
    };
  }

  // Instagram (post or reel)
  const ig = u.match(/instagram\.com\/(p|reel|tv)\/([A-Za-z0-9_-]+)/);
  if (ig) {
    const kind = ig[1];
    const code = ig[2];
    return {
      type: "instagram",
      embedUrl: `https://www.instagram.com/${kind}/${code}/embed/`,
      thumbnail: null,
      providerLabel: "Instagram",
    };
  }

  // TikTok
  const tt = u.match(/tiktok\.com\/.*\/video\/(\d+)/);
  if (tt) {
    return {
      type: "tiktok",
      embedUrl: `https://www.tiktok.com/embed/v2/${tt[1]}`,
      thumbnail: null,
      providerLabel: "TikTok",
    };
  }

  // Direct MP4/upload
  if (/\.(mp4|webm|mov|m4v)(\?|$)/i.test(u)) {
    return { type: "file", embedUrl: u, thumbnail: null, providerLabel: "Vídeo" };
  }

  return { type: "unknown", embedUrl: u, thumbnail: null, providerLabel: "" };
}
